import {API} from "@/api/API";
import {PromocodesSchema} from "@/views/Admin/Events/Event/Promocodes/Promocodes.schema";

const getResourcesList = async (service: any, config: any) => {
    try {
        const {data = [], meta} = await service(config);
        return {data, meta};
    } catch {
        return {data: [], meta: PromocodesSchema.promocodes.meta};
    }
};

export const PromocodesMethods = {getResourcesList}
